import React from 'react'
import classnames from 'classnames'

import DateTimeInput from '_components/datetimeInput'

import styles from './styles.css'

const EventFormModal = ({
  nameValue,
  nameOnChange,
  dateValue,
  dateOnChange,
  durationValue,
  durationOnChange,
  button1Name,
  button2Name,
  button1Function,
  button2Function,
  onKeyPress,
}) => (
  <div className={classnames(styles.form)}>
    <input
      className={classnames(styles.input)}
      type="text"
      placeholder="Name"
      value={nameValue}
      onChange={nameOnChange}
      onKeyPress={onKeyPress}
    />
    <DateTimeInput
      type="text"
      placeholder="Date and Time"
      className={classnames(styles.input)}
      value={dateValue}
      onChange={dateOnChange}
      onKeyPress={onKeyPress}
    />
    <input
      className={classnames(styles.input)}
      type="text"
      placeholder="Duration(Hours)"
      value={durationValue}
      onChange={durationOnChange}
      onKeyPress={onKeyPress}
    />
    <div>
      <button className={classnames(styles.button)} onClick={button1Function}>
        {button1Name}
      </button>
      <button className={classnames(styles.button)} onClick={button2Function}>
        {button2Name}
      </button>
    </div>
  </div>
)

export default EventFormModal



// WEBPACK FOOTER //
// ./src/views/reconcile/event-form-modal/index.js